function AccessDenied() {
  return (
    <div className="text-center">
      <h1>Åtkomst saknas</h1>
      <div className="mb-3">Du har inte behörighet att visa denna sida.</div>
    </div>
  );
}

export default AccessDenied;
